var _style, _g, _circle, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.5 70.6",
    style: {
      enableBackground: "new 0 0 70.5 70.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0054A5;}\n\t.st1{fill:none;stroke:#2E3191;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{opacity:0.62;}\n\t.st4{fill:#59595C;stroke:#59595C;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#59595C;stroke:#59595C;stroke-miterlimit:10;}\n\t.st6{fill:#59595C;stroke:#59595C;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:#59595C;stroke:#59595C;stroke-width:1;stroke-miterlimit:10.0002;}\n\t.st8{fill:#59595C;stroke:#59595C;stroke-width:1;stroke-miterlimit:9.9997;}\n\t.st9{fill:#59595C;stroke:#59595C;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st10{fill:#59595C;stroke:#59595C;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#F4DCEA;stroke:#767C7E;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st12{fill:none;stroke:#767C7E;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st13{fill:#BCBDBF;stroke:#767C7E;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st14{fill:none;stroke:#F1F1F1;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st15{fill:#D1D2D3;}\n\t.st16{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st17{stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#767C7E;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000076568355311025690080000012106436387171144860_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.3,
    cy: 35.3,
    r: 32.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35.3,
    cy: 35.3,
    r: 32.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000012457700406404717770000007560015879174267523_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 35.2549,
    cy: 35.2986,
    r: 27.0064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8DD7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00ADEE"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 35.3,
    cy: 35.3,
    r: 27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35.3,
    cy: 35.3,
    r: 27
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36,28.7c0,0,0.2-1.9-0.8-4.8c-1-2.9-2.1-4.5-2.1-4.5s-2.3,2.4-3.3,4.4s-1.9,4.4-1.9,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.5,34.6c0,0,0.6-4.6,0-8c-0.6-3.5-1.4-5.5-1.4-5.5s-2.9,2.3-4.3,4.3S42.9,30,42.9,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.9,42.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39.8,26.2c8.9,1.3,10.7,5.4,11.4,8.6c0.8,3.5-0.3,6.3-2.6,9.1c-3,3.7-9.6,6.3-18.5,4.3 c-2.8-0.6-7.2-2.9-7.5-8c-0.1-2.9,0.5-4.8,2.1-7.8c1.4-2.5,3-4,4.9-5.2C31.4,26.5,36.2,25.7,39.8,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.6,27.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 40.2,
    cy: 34.3,
    rx: 2.8,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.7,32.8c0,0-0.9,0.4-1.1,1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 29.8,
    cy: 33.3,
    rx: 2.8,
    ry: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M29.4,31.8c0,0-0.9,0.4-1.1,1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1256 -0.9921 0.9921 0.1256 -13.3248 69.3685)",
    className: "st7",
    cx: 32.7,
    cy: 42.2,
    rx: 3.8,
    ry: 7.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.126 -0.992 0.992 0.126 -11.3444 67.2403)",
    className: "st8",
    cx: 32.5,
    cy: 40.1,
    rx: 0.8,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.4,40.1l-0.6,2.4c0,0,0.4,0.9,1.2,1c0.8,0.1,1.9-0.5,1.9-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M19,40.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.8,42.5c0,0-1,0.7-1.8,0.4c-0.9-0.3-1.2-0.9-1.2-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M36.4,41c0,0,8,0.4,10.3,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M36.2,42c0,0,7.8,1.6,9.8,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29,40.2c0,0-7.9-1.5-10.9,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.7,41c0,0-8.1-0.5-10.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M42.6,26.8c0,0-2.2,1-2.8,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M38.4,26.1c0,0-2,2.5-2.3,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M34.8,26.2c0,0-1.4,2-1.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M51.1,38.7c0,0-2.4,1-4.3,0.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33.8,28.9c0,0,0.2-1.8-0.8-4.6s-2-4.4-2-4.4s-2.2,2.3-3.2,4.2s-1.9,4.3-1.9,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M48.6,34.6c0,0,0.6-4.5,0-7.8s-1.4-5.3-1.4-5.3s-2.8,2.2-4.2,4.2s-2.6,4.4-2.6,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M21.1,42.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M37.4,26.5c8.5,1.3,10.3,5.2,11,8.4c0.8,3.4-0.3,6.1-2.5,8.9C43,47.4,36.7,49.9,28,48 c-2.7-0.6-7-2.9-7.2-7.8c-0.1-2.8,0.5-4.7,2-7.5c1.3-2.4,2.9-3.9,4.8-5C29.3,26.8,33.9,26,37.4,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M39.1,27.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8,
    cy: 34.4,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M37.3,33c0,0-0.9,0.4-1,1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.8,
    cy: 33.4,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M27.3,31.9c0,0-0.9,0.4-1,1.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1273 -0.9919 0.9919 0.1273 -15.1927 66.9769)",
    className: "st15",
    cx: 30.5,
    cy: 42.1,
    rx: 3.7,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1273 -0.9919 0.9919 0.1273 -13.1183 64.8994)",
    cx: 30.3,
    cy: 39.9,
    rx: 0.8,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M30.3,40l-0.6,2.3c0,0,0.4,0.9,1.1,1s1.8-0.4,1.8-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M17.4,40.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M29.7,42.3c0,0-0.9,0.7-1.8,0.4c-0.8-0.3-1.2-0.8-1.2-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M34.1,40.8c0,0,7.7,0.4,10,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M33.9,41.9c0,0,7.5,1.6,9.4,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M27,40.1c0,0-7.7-1.4-10.6,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M25.7,40.9c0,0-7.8-0.5-10.4,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M40.1,27.1c0,0-2.1,1-2.7,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M36,26.4c0,0-2,2.4-2.2,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M32.6,26.5c0,0-1.3,2-1.5,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M48.3,38.7c0,0-2.3,1-4.2,0.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.4ec3c0070fa3b4e22a90b7b2eb085148.svg";
export { ForwardRef as ReactComponent };